import store from '../../store';

export default class NegotiationsService {
  static processNegotiations(resp) {
    for (let i = 0; i < resp.length; i += 1) {
      if (store.state.NegotiationsModule.negotiationIds.findIndex(m => m === resp[i].BetSlipGroupID) < 0) {
        let betslipGroup = JSON.parse(resp[i].JsonBetslip);
        /* We receive the messages for all languases, and here we save only the message for the user language
        * If no message for user language set the system message
        */
        betslipGroup.NegotiationMessage = betslipGroup.NegotiationMessage !== null ?
          betslipGroup.NegotiationMessage[window.btoLangId] || betslipGroup.NegotiationMessage[0] || '' : '';

        store.dispatch('startCounter', betslipGroup);
        store.commit('addNegotiation', betslipGroup);
      }
    }
  }

  static totalNegotiationWidget() {
    let counter = [];
    const allNegotiations = store.state.NegotiationsModule.negotiations.Data;
    const negotiationsIds = store.state.NegotiationsModule.negotiationIds;
    for (let i = 0; i < negotiationsIds.length; i += 1) {
      const negotiation = allNegotiations.find(n => n.BetSlipGroupID === negotiationsIds[i]);
      counter.push(store.state.NegotiationsModule.negotiationCounters[negotiation.BetSlipGroupID]);
    }
    const total = counter.map(c => c.total);
    if (typeof counter !== 'undefined' && typeof total !== 'undefined') {
      return total;
    }
  }
}
